import { QuestionnaireCategory, UpdateQuestionnaireCategoryBulkInput } from '@/models/gen/graphql';

import { UpdateQuestionnaireCategoryBulkDocument } from '@/api/queries';
import { generateUpdateBulkPayload } from '@/utils';
import graphApi from '@/api';

const [runUpdateCategory] = graphApi(UpdateQuestionnaireCategoryBulkDocument);

export const updateCategory = async (categories: Partial<QuestionnaireCategory>[]) => {
  const updates = generateUpdateBulkPayload(categories);
  const input: UpdateQuestionnaireCategoryBulkInput = { updates };
  return await runUpdateCategory({ input });
};

export default updateCategory;
